import { ProcessStatusCode } from "@/types/code.types";

export type PublicationListEditorInfoFilterKey =
  | "allEditorInfo"
  | "mcEditorInfo"
  | "ftEditorInfo";

export interface PublicationListEditorInfoFilterType {
  key: PublicationListEditorInfoFilterKey;
  name: string;
  isAllInfo: boolean;
  code?: ProcessStatusCode;
}

export const PUBLICATION_LIST_EDITOR_INFO_FILTER: PublicationListEditorInfoFilterType[] =
  [
    {
      key: "allEditorInfo",
      name: "All Editor",
      isAllInfo: true,
    },
    {
      key: "mcEditorInfo",
      name: "MC Editor",
      code: "S112",
      isAllInfo: false,
    },
    {
      key: "ftEditorInfo",
      name: "FT Editor",
      code: "S911",
      isAllInfo: false,
    },
  ];

export const PUBLICATION_LIST_EDITOR_INFO_FILTER_KEY = [
  "allEditorInfo",
  "mcEditorInfo",
  "ftEditorInfo",
] as const;
